import React, { useState, useEffect, useRef } from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useNavigate } from 'react-router';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import DialogMsg from '../../global/DialogMsg';

const { GetConsents, GetConsentFile } = onBoardingEkycServices;

const TermService = () => {
  const navigate = useNavigate();
  const frameRef = useRef();
  // const [ifCheck, setIfCheck] = useState(false);
  const [ifCheck, setIfCheck] = useState(true); // for now bypass checkbox of acknowledge
  const [CheckError, setCheckError] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [htmlDataForIframe, setHtmlDataForIframe] = useState('Loading....');

  // console.log('htmlDataForIframe', htmlDataForIframe);

  // GetConsentsApi API
  const GetConsentsApi = async () => {
    try {
      setOpenloader(true);
      const GetConsentsResponse = await GetConsents();
      if (GetConsentsResponse.status === 'Success') {
        if (GetConsentsResponse.data.length > 0) {
          // no need of sorting
          // const sortConsentSeq = GetConsentsResponse.data.sort(
          //   (a, b) => a.consentSeq - b.consentSeq
          // ); // sorting
          // const sequence2 = sortConsentSeq.filter(
          //   (ByConsentSeq) => ByConsentSeq?.consentSeq === 2 && ByConsentSeq?.isShow === true
          // )[0].url;
          const sequence2 = GetConsentsResponse.data.filter(
            (ByConsentSeq) => ByConsentSeq?.consentSeq === 2 && ByConsentSeq?.isShow === true
          )[0].url;

          if (sequence2 !== null && sequence2 !== '' && sequence2 !== undefined) {
            GetConsentFileApi(sequence2);
          } else {
            // navigate('/in/terms-of-privacy-protection');
          }
        } else {
          setOpenDialogeMsg(true);
          setDialogMsg('Data not found');
        }
      } else if (GetConsentsResponse.status === 'Failure') {
        navigate('/in/terms-of-privacy-protection');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };
  // GetConsents file API
  const GetConsentFileApi = async (consentsUrl) => {
    try {
      setOpenloader(true);
      const credential = { userId: 1, fileName: consentsUrl };
      const GetConsentsResponse = await GetConsentFile(credential);
      setHtmlDataForIframe(GetConsentsResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  useEffect(() => {
    GetConsentsApi();
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Terms of service" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box mb={2} className="termServiceBox hScrollbar">
          {/* <Typography variant="subtitle1">1.Definition</Typography> */}
          <List className="ListOuter">
            <ListItem disablePadding className="listItem">
              <Box
                className="iframeStyle quill"
                ref={frameRef}
                onScroll={(e) => {
                  if (e.target.scrollTop > 30) {
                    // setDisableButton(false);
                  }
                }}
              >
                <div
                  className="kl-editor"
                  dangerouslySetInnerHTML={{ __html: htmlDataForIframe }}
                />
              </Box>
            </ListItem>
          </List>
        </Box>
        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs="12" sm="6" md="6" marginBottom={3}>
            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  sx={{ color: '#3C3C4B', '&.Mui-checked': { color: '#03989a    ' } }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setIfCheck(true);
                      setCheckError(false);
                    } else {
                      setIfCheck(false);
                    }
                  }}
                />
              }
              label="Acknowledge and accept"
            />
            {CheckError && (
              <Typography variant="body2" sx={{ color: 'red' }}>
                Please choose to acknowledge and accept the terms.
              </Typography>
            )}
          </Grid>
          <Grid item xs="12" sm="6" md="6" marginBottom={3} textAlign="right">
            <Button
              className="mainBtn"
              onClick={(e) => {
                if (ifCheck === true) {
                  navigate('/in/terms-of-privacy-protection');
                } else {
                  setCheckError(true);
                  return '';
                }
              }}
            >
              Agree
            </Button>
          </Grid>
        </Grid>

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default TermService;
